import { Paper, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface IMedicationOption {
  disabled?: boolean;
  text: string;
  onClick: () => void;
  isSelected: boolean;
  description?: string;
}
export const MedicationOption = (props: IMedicationOption) => {
  const isDesktop = useIsDesktop();
  if (props.description && props.isSelected && !isDesktop) {
    return <OptionLabelWithDescription {...props} />;
  }

  return (
    <OptionLabel
      isSelected={props.isSelected}
      onClick={props.onClick}
      text={props.text}
      disabled={props.disabled}
      description={props.description}
    />
  );
};

export const OptionLabel = (props: IMedicationOption) => {
  const isDesktop = useIsDesktop();

  return (
    <Paper
      onClick={props.disabled ? undefined : props.onClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: props.isSelected ? '3px solid #D59DFF' : '0.5px solid #D59DFF',
        boxShadow: '0px 2px 14px 0px rgba(58, 110, 236, 0.08)',
        borderRadius: '12px',
        padding: isDesktop ? undefined : '16px 0',
        width: 'min(100% ,  360px)',
        cursor: props.disabled ? undefined : 'pointer',
        textAlign: 'center',
        minHeight: isDesktop ? '77px' : undefined,
        bgcolor: props.disabled ? 'rgba(198, 211, 219, 0.16)' : undefined,
        fontFamily: 'Assistant',
      }}
      component='button'
      role='radio'
    >
      <Typography variant='body3'>{props.text}</Typography>
      <Typography variant='body7'>{props.description}</Typography>
    </Paper>
  );
};

export const OptionLabelWithDescription = (props: IMedicationOption) => {
  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: 'min(100% , 360px)',
        border: `0.5px solid rgba(198, 211, 219, 0.64)`,
        boxShadow: ` 0px 4px 16px rgba(45, 112, 217, 0.08)`,
        borderRadius: '16px',
        backgroundColor: '#FAFBFC',
      }}
      role='radio'
    >
      <OptionLabel
        isSelected={props.isSelected}
        onClick={props.onClick}
        text={props.text}
        description={props.description}
      />
    </Paper>
  );
};
